import React from 'react';
import { Select } from 'antd';
import PropTypes from 'prop-types';
import useParams from '../useParams';

const ParamSelect = ({ paramType, ...restProps }) => {
  const [options, areOptionsLoading] = useParams(paramType);

  return (
    <Select {...restProps} loading={areOptionsLoading} disabled={areOptionsLoading}>
      {options.map((option) => (
        <Select.Option key={option.id} value={option.id}>
          {option.name}
        </Select.Option>
      ))}
    </Select>
  );
};

ParamSelect.propTypes = {
  paramType: PropTypes.string.isRequired,
};

export default ParamSelect;
